import Vue from "vue";
import DashboardPlugin from "./plugins/dashboard-plugin";
import App from "./App.vue";
import { BootstrapVue, IconsPlugin } from "bootstrap-vue";
import store from "./store";
import VueCookies from "vue-cookies";
import ElementUI from "element-ui";
import localeEs from 'element-ui/lib/locale/lang/es';
import "element-ui/lib/theme-chalk/index.css";
import "@/components/Spinner-Load/loader.css";
import { spinner } from "@/components/Spinner-Load/loader.js";
const loader = spinner();

// router setup
import router from "./routes/router";
import swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.css";
// plugin setup
Vue.use(DashboardPlugin);
Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
Vue.use(VueCookies);
Vue.use(ElementUI, { locale: localeEs });

/* eslint-disable no-new */
new Vue({
  store,
  el: "#app",
  render: (h) => h(App),
  router,
  mounted() {
    this.startSessionCheck();
  },
  methods: {
    startSessionCheck() {
      this.checkSesionState;
      setInterval(this.checkSesionState, 3000);
    },
    checkSesionState() {
      if (
        (
          this.$route.name != "login" &&
          this.$route.name != null &&
          !this.$cookies.isKey("catecumen_token")) ||
        (
          this.$route.name != "login" &&
          this.$route.name != null &&
          !this.$cookies.isKey("catecumen_token"))
      ) {
        loader.close();
        if (document.getElementById("loader")) {
          document.getElementById("loader").remove();
        }
        swal
          .fire({
            title: `Error`,
            text: "Usuario no identificado, inicie sesión nuevamente",
            buttonsStyling: false,
            confirmButtonClass: "btn btn-warning",
            icon: "warning",
          })
          .then(() => {
            this.$router.push({ name: "login" });
          });
      }
    },
  },
});
